module.exports = __webpack_public_path__ + "img/BookmarkSpanishLogoWhite.74052081.png";